<template>
  <div class="container">
    <BaseBread>
      <BaseBreadItem to="/">首页</BaseBreadItem>
      <BaseBreadItem>产品中心</BaseBreadItem>
    </BaseBread>
    <div class="product-list">
      <!-- 左：侧边栏组件 -->
      <ProductLeftMenu :menuList="menuList" @category-change="handleCategoryChange" :activeCategory="activeCategoryId"/>
      <!-- 右：内容 -->
      <transition name="fade" mode="out-in">
        <ProductContent :categoryId="activeCategoryId" :key="activeCategoryId"/>
      </transition>
    </div>
  </div>
</template>

<script setup>
import { findProductCategory } from "/composables/api/product";

const menuList = ref([]);
findProductCategory().then(data => {
  if (data && data.data && data.data.list) {
    menuList.value = data.data.list
  } else {
    menuList.value = []
  }
}).catch(error => {
  console.error('获取产品分类失败:', error)
  menuList.value = []
})

// 当前激活的分类ID
const activeCategoryId = ref('0');

// 处理分类变更
const handleCategoryChange = (categoryId) => {
  // 确保categoryId是字符串类型
  activeCategoryId.value = String(categoryId);
}
</script>

<style scoped lang="less">
.product-list {
  display: flex;
  min-height: 600px;
  margin-bottom: 30px;
  
  // 添加右侧内容区域固定宽度和样式
  > div:last-child,
  > .fade-enter-active,
  > .fade-leave-active {
    flex: 1;
    overflow: hidden;
    position: relative;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
